import { useEffect, useRef, useState } from "react";

const TICKER_SYMBOLS = [
  { proName: "BSE:HDFCBANK", title: "HDFC Bank" },
  { proName: "BSE:BHARTIARTL", title: "Airtel" },
  { proName: "BSE:OLAELEC", title: "Ola Electric" },
  { proName: "BSE:TCS", title: "TCS" },
  { proName: "BSE:JINDALSTEL", title: "Jindal Steel" },
  { proName: "BSE:HEROMOTOCO", title: "Hero MotoCorp" },
  { proName: "BSE:RELIANCE", title: "Reliance" },
];

const MarketTicker = () => {
  const widgetRef = useRef(null);
  const [isLight, setIsLight] = useState(false);

  useEffect(() => {
    try {
      if (typeof document !== "undefined") {
        setIsLight(document.documentElement.classList.contains("light"));
      }
    } catch (_) {}
  }, []);

  useEffect(() => {
    try {
      const container = widgetRef.current;
      if (!container) return undefined;

      // TradingView widget needs the container to have the widget div BEFORE the script runs
      const widgetDiv = document.createElement("div");
      widgetDiv.className = "tradingview-widget-container__widget";
      container.innerHTML = "";
      container.appendChild(widgetDiv);

      const script = document.createElement("script");
      script.type = "text/javascript";
      script.async = true;
      // NOTE: do NOT set crossOrigin — TradingView CDN has no CORS headers
      script.onerror = () => {}; // silence load errors silently
      script.src = "https://s3.tradingview.com/external-embedding/embed-widget-ticker-tape.js";
      script.innerHTML = JSON.stringify({
        symbols: TICKER_SYMBOLS,
        colorTheme: isLight ? "light" : "dark",
        locale: "in",
        largeChartUrl: "",
        isTransparent: true,
        showSymbolLogo: true,
        displayMode: "regular",
      });
      container.appendChild(script);

      return () => {
        try { container.innerHTML = ""; } catch (_) {}
      };
    } catch (e) {
      console.warn("MarketTicker init skipped:", e);
    }
  }, [isLight]);

  return (
    <div className="market-ticker-shell fixed left-0 right-0 top-0 z-[80] overflow-hidden border-b border-[#00FF88]/20 bg-white/95 dark:bg-[#030505]/95 shadow-[0_10px_30px_rgba(0,0,0,0.15)] dark:shadow-[0_10px_30px_rgba(0,0,0,0.35)] backdrop-blur-xl">
      <div className="absolute inset-y-0 left-0 z-10 w-12 bg-gradient-to-r from-white dark:from-[#030505] to-transparent pointer-events-none" />
      <div className="absolute inset-y-0 right-0 z-10 w-12 bg-gradient-to-l from-white dark:from-[#030505] to-transparent pointer-events-none" />
      <div className="absolute inset-x-0 bottom-0 h-px bg-gradient-to-r from-transparent via-[#00FF88]/70 to-transparent pointer-events-none" />
      <div className="mx-auto h-full max-w-[1920px] px-2">
        <div ref={widgetRef} className="tradingview-widget-container h-full w-full" />
      </div>
    </div>
  );
};

export default MarketTicker;
